export default (permission, permissions) => {
  const flatten_permissions = permissions.flat();
  const found_permission = flatten_permissions.find(p => p === permission);
  return !!found_permission;
};
